import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FileResult } from '../../models/file-result.model';
import { saveAs } from '@progress/kendo-file-saver';
import { FacilityExportService } from '../../services/facility-export.service';
import { PaginationInstance } from 'ngx-pagination';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-facility-export-file-status',
  templateUrl: './facility-export-file-status.component.html',
  styleUrl: './facility-export-file-status.component.css'
})
export class FacilityExportFileStatusComponent {

  @Input() hospid: number;
  @Input() facilityExportRequestedFiles: any[] = []; // Data from parent
  @ViewChild('pagination') pagin: ElementRef;
  // @ViewChild('filterlink') flink: ElementRef;
  private $subscriptions: Subscription = new Subscription();
  downloadedFile: any;
  private itemClicked = false;

  // Pagination
  public searchText = '';
  public maxSize = 7;
  public directionLinks = true;
  public autoHide = false;
  public responsive = false;

  public config: PaginationInstance = {
      id: 'paginationId',
      itemsPerPage: 10,
      currentPage: 1
  };

  public labels: any = {
      previousLabel: 'Previous',
      nextLabel: 'Next',
      screenReaderPaginationLabel: 'Pagination',
      screenReaderPageLabel: 'page',
      screenReaderCurrentLabel: `You're on page`
  };

  public isItemSelected() {
    return this.itemClicked === true;
  }


  constructor(private dataService: FacilityExportService) { }

  ngOnInit() {
  }

  refreshFileStatus() {
    this.config.currentPage = 1;
  }

  private handleFileDownload(fileid: number) {
    const $downloadSubscription = this.dataService.getFacilityExportFile(this.hospid, fileid)
      .subscribe((response: any) => {
        const result = response as FileResult;
        if (result.Ok === true) {
          const blob = new Blob([result.Data], { type: 'application/x-zip-compressed' });
          saveAs(blob, result.FileName);
        }
      });
    this.$subscriptions.add($downloadSubscription);
  }

  isDownloadDisabled(filename: string): boolean {
    return false;
  }

  downloadFile(fileID: number) {
    if (fileID) {
      this.handleFileDownload(fileID);
    }
  }

  getActionCss(status) {
    return this.dataService.getActionCss(status);
  }

  getStatusCss(status) {
    return this.dataService.getStatusCss(status);
  }


  // Pagination
  onPageChange(page: number) {
    this.config.currentPage = page;
  }
  onPageBoundsCorrection(page: number) {
      this.config.currentPage = page;
  }

  private Unsubscribe() {
    if (this.$subscriptions) {
      this.$subscriptions.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.Unsubscribe();
  }
}
